import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=ea008240&scoped=true"
import script from "./Notice.vue?vue&type=script&lang=js"
export * from "./Notice.vue?vue&type=script&lang=js"
import style0 from "./Notice.vue?vue&type=style&index=0&id=ea008240&prod&lang=scss&scoped=true"
import style1 from "./Notice.vue?vue&type=style&index=1&id=ea008240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea008240",
  null
  
)

export default component.exports